import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'
import { OriginService } from '../origin.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { FuseTranslationLoaderService } from '../../../../../core/services/translation-loader.service'
import { locale } from '../i18n/nl'
import { OriginModel } from '../models/origin.model'

@Component({
  selector: 'app-origin-details',
  templateUrl: './origin-details.component.html',
  styleUrls: ['./origin-details.component.scss'],
})
export class OriginDetailsComponent implements OnInit, OnDestroy {
  origin: OriginModel
  onUserChanged: Subscription
  originForm: FormGroup

  @ViewChild('titleInput') titleInputField

  constructor(
    private originService: OriginService,
    private formBuilder: FormBuilder,
    private translationLoader: FuseTranslationLoaderService,
  ) {
    this.translationLoader.loadTranslations(locale)
  }

  ngOnInit() {
    // Subscribe to update the current administration
    this.onUserChanged = this.originService.onOriginChanged
      .map(origin => {
        this.origin = origin
        this.originForm = this.createOrginForm()
        this.focusTitleField()
      })
      .subscribe()
  }

  focusTitleField() {
    setTimeout(() => {
      this.titleInputField.nativeElement.focus()
    })
  }

  createOrginForm() {
    return this.formBuilder.group({
      id: [this.origin.id],
      name: [this.origin.name, [Validators.required]],
      description: [this.origin.description],
    })
  }

  /**
   * Update a Origin
   */
  updateOrign() {
    this.origin.name = this.originForm.get('name').value
    this.origin.description = this.originForm.get('description').value

    this.originService.update(this.origin).subscribe()
  }

  /**
   *
   * @param event
   */
  deleteOrigin(event) {
    event.stopPropagation()
  }

  /**
   *
   */
  ngOnDestroy() {
    this.onUserChanged.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/origin-details/origin-details.component.ts